// GCO Extranet - Main JavaScript Entry Point
//
// This file is bundled by esbuild. Legacy libraries (Prototype.js, etc.)
// are imported for their side effects - they set up global variables.

// =============================================================================
// Rails UJS - enables method: :post/delete/etc. on links, data-confirm, etc.
// =============================================================================
import Rails from "@rails/ujs"
Rails.start()

// =============================================================================
// Prototype.js and extensions (order matters - these set global $, $$, etc.)
// =============================================================================
import "./vendor/prototype"
import "./vendor/effects"
import "./vendor/dragdrop"
import "./vendor/controls"
import "./vendor/date"
import "./vendor/modalbox"
import "./vendor/proto.menu"

// =============================================================================
// jQuery - loaded via separate script tag before this bundle
// =============================================================================
// jQuery and jQuery UI are loaded via <script> tags before this bundle runs.
// We don't import them here - they set window.jQuery directly.
// The gco-styles plugins below access window.jQuery which should already be set.

// =============================================================================
// GCO Styles vendor plugins (jQuery-based)
// =============================================================================
import "./gco-styles/datatables"
import "./gco-styles/dropdown"
import "./gco-styles/modals"
import "./gco-styles/dimmer"
import "./gco-styles/transition"
import "./gco-styles/tooltips"
import "./gco-styles/icheck"
import "./gco-styles/easytabs"
import "./gco-styles/multiselect"
import "./gco-styles/moment"
import "./gco-styles/pickaday"
import "./gco-styles/select-and-search"
import SortableJS from "./gco-styles/sortable"
window.SortableJS = SortableJS;

// =============================================================================
// Application helpers
// =============================================================================
import "./controllers/global_plugin_handlers"

// =============================================================================
// Utility functions (must be global for legacy scripts)
// =============================================================================

// sprintf implementation for string formatting
function str_repeat(i, m) {
  for (var o = []; m > 0; o[--m] = i);
  return o.join('');
}
window.str_repeat = str_repeat;

function sprintf() {
  var i = 0, a, f = arguments[i++], o = [], m, p, c, x, s = '';
  while (f) {
    if (m = /^[^\x25]+/.exec(f)) {
      o.push(m[0]);
    }
    else if (m = /^\x25{2}/.exec(f)) {
      o.push('%');
    }
    else if (m = /^\x25(?:(\d+)\$)?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(f)) {
      if (((a = arguments[m[1] || i++]) == null) || (a == undefined)) {
        throw('Too few arguments.');
      }
      if (/[^s]/.test(m[7]) && (typeof(a) != 'number')) {
        throw('Expecting number but found ' + typeof(a));
      }
      switch (m[7]) {
        case 'b': a = a.toString(2); break;
        case 'c': a = String.fromCharCode(a); break;
        case 'd': a = parseInt(a); break;
        case 'e': a = m[6] ? a.toExponential(m[6]) : a.toExponential(); break;
        case 'f': a = m[6] ? parseFloat(a).toFixed(m[6]) : parseFloat(a); break;
        case 'o': a = a.toString(8); break;
        case 's': a = ((a = String(a)) && m[6] ? a.substring(0, m[6]) : a); break;
        case 'u': a = Math.abs(a); break;
        case 'x': a = a.toString(16); break;
        case 'X': a = a.toString(16).toUpperCase(); break;
      }
      a = (/[def]/.test(m[7]) && m[2] && a >= 0 ? '+'+ a : a);
      c = m[3] ? m[3] == '0' ? '0' : m[3].charAt(1) : ' ';
      x = m[5] - String(a).length - s.length;
      p = m[5] ? str_repeat(c, x) : '';
      o.push(s + (m[4] ? a + p : p + a));
    }
    else {
      throw('Huh ?!');
    }
    f = f.substring(m[0].length);
  }
  return o.join('');
}
window.sprintf = sprintf;

// IE select innerHTML fix
function select_innerHTML(objeto, innerHTML) {
    objeto.innerHTML = ""
    var selTemp = document.createElement("micoxselect")
    var opt;
    selTemp.id = "micoxselect1"
    document.body.appendChild(selTemp)
    selTemp = document.getElementById("micoxselect1")
    selTemp.style.display = "none"
    innerHTML = innerHTML.replace(/<option/gi, "<span").replace(/<\/option/gi, "</span")
    selTemp.innerHTML = innerHTML

    for (var i = 0; i < selTemp.childNodes.length; i++) {
        var spantemp = selTemp.childNodes[i];

        if (spantemp.tagName) {
            opt = document.createElement("OPTION")

            if (document.all) {
                objeto.add(opt)
            } else {
                objeto.appendChild(opt)
            }

            for (var j = 0; j < spantemp.attributes.length; j++) {
                var attrName = spantemp.attributes[j].nodeName;
                var attrVal = spantemp.attributes[j].nodeValue;
                if (attrVal) {
                    try {
                        opt.setAttribute(attrName, attrVal);
                        opt.setAttributeNode(spantemp.attributes[j].cloneNode(true));
                    } catch(e) {}
                }
            }
            opt.value = spantemp.getAttribute("value")
            opt.text = spantemp.innerHTML
            opt.selected = spantemp.getAttribute('selected');
            opt.className = spantemp.className;
        }
    }
    document.body.removeChild(selTemp)
    selTemp = null
}
window.select_innerHTML = select_innerHTML;

// Indicator class for showing loading spinners
var Indicator = Class.create();
Indicator.prototype = {
  element: null,
  initialize: function(trigger, wrapper){
    var trigger = $(trigger);
    var wrapper = typeof(wrapper) != 'undefined' ? wrapper : "div";
    this.element = trigger.up(wrapper).select(".loader").first();
  },
  show: function(){
    this.element.show();
  },
  hide: function(){
    this.element.hide();
  }
};
window.Indicator = Indicator;
